import * as util from './function'
export default util
